import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Image,
  Space,
  Switch,
} from "antd";
import withRouter from "../withRouter";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import React, { Component } from "react";
import mailIcon from "../assets/images/NewDesign/AlertFormIcons/email.svg";
import mailIconBlue from "../assets/images/NewDesign/AlertFormIcons/emailblue.svg";
import notificationIcon from "../assets/images/NewDesign/AlertFormIcons/notification.svg";
import notificationIconBlue from "../assets/images/NewDesign/AlertFormIcons/notificationblue.svg";
import notificationbell from "../assets/images/NewDesign/AlertFormIcons/notification-bell.svg";
import notificationbellblue from "../assets/images/NewDesign/AlertFormIcons/notification-bellblue.svg";
import carregistration from "../assets/images/NewDesign/AlertFormIcons/car-registration.svg";
import carregistrationblue from "../assets/images/NewDesign/AlertFormIcons/car-registrationblue.svg";
import thermometerIcon from "../assets/images/NewDesign/AlertFormIcons/thermometerIcon.svg";
import thermometerIconBlue from "../assets/images/NewDesign/AlertFormIcons/thermometerIconBlue.svg";
import speedradar from "../assets/images/NewDesign/AlertFormIcons/speed-radar.svg";
import speedradarBlue from "../assets/images/NewDesign/AlertFormIcons/speed-radarBlue.svg";
import distance from "../assets/images/NewDesign/AlertFormIcons/distance.svg";
import distanceBlue from "../assets/images/NewDesign/AlertFormIcons/distanceBlue.svg";
import locationIcon from "../assets/images/NewDesign/AlertFormIcons/locationIcon.svg";
import locationIconBlue from "../assets/images/NewDesign/AlertFormIcons/locationIconBlue.svg";
import { format, addMinutes } from "date-fns";
import AlertStore from "../store/AlertStore";
import CompanyStore from "../store/CompanyStore";
const { Option } = Select;

class AlertAdd2 extends Component {
  formRef = React.createRef();
  constructor(props, context) {
    super(props);

    this.state = {
      selectedAlertName: "",
      companyId: "",
      selectedVehicleIds: [],
      selectedActions: [],
      ruleId: 0,
      selectedAlertObject: {},
      loading: false,

      isMailSelected: false,
      isNotificationSelected: false,
      isWebPushNotificationSelected: false,

      isAssetNoSelected: true,
      isSpeedSelected: true,
      isDistanceSelected: true,
      isLocationSelected: true,
      isTempratureSelected: false,

      bletemp1: false,
      bletemp2: false,
      bletemp3: false,
      bletemp4: false,

      blehumidity1: false,
      blehumidity2: false,
      blehumidity3: false,
      blehumidity4: false,

      selectAllVehicles: false,
      active: false,
    };

    this.alertStore = new AlertStore(this);
    this.companyStore = new CompanyStore(this);
  }

  closeModal = () => {
    this.props.closeModal();
  };

  timeOptions = () => {
    const timeArray = [];

    let startTime = new Date(2000, 0, 1, 0, 0);

    let endTime = new Date(2000, 0, 1, 24, 0);
    for (let time = startTime; time < endTime; time = addMinutes(time, 30)) {
      const formattedTime = format(time, "HH:mm:ss");
      var ob = {
        formattedTime: formattedTime,
        time: time,
      };
      timeArray.push(ob);
    }

    return timeArray.map((data) => {
      return (
        <Select.Option key={data.formattedTime} value={data.formattedTime}>
          {format(data.time, "h:mm aa")}
        </Select.Option>
      );
    });
  };

  handleChange = async (comp) => {
    await this.setState({ companyId: comp.value });
    if (!this.props.params.id) {
      this.context.viewStateStore.setAlertStates({ companyId: comp.value });
    }
    await this.setState({ companyId: comp.value });
    this.formRef.current.setFieldsValue({
      companyId: comp.value,
    });
    await this.alertStore.getVehicles(comp.value);

    await this.setState({ loadData: 1 });
  };

  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.context.viewStateStore.setAlertStates({
        companyId: this.props.getUserData().userCompanyId,
      });

      this.setState({ companyId: this.props.getUserData().userCompanyId });

      await this.alertStore.getVehicles(this.props.getUserData().userCompanyId);
    }

    await this.alertStore.alertNamesList();
    await this.setState({ loadList: 1 });
    const Id = this.props.ruleId;

    if (Id) {
      this.fillData(Id);
      this.setState({ Id: Id });
    }
    await this.setState({ loadList: 1 });
  }

  async fillData(Id) {
    const getAlertDetails = await this.alertStore.getAlertData(Id);

    await this.alertStore.getVehicles(getAlertDetails.companyId);

    const singleData = await this.companyStore.getCompanyDataById(
      getAlertDetails.companyId
    );
    const savedVehicleIds = getAlertDetails.vehicleId || []; // array from DB
    const allVehicleIds =
      this.alertStore?.vehicleList?.map((v) => v.vehicleId) || [];

    // Check if ALL vehicles are selected
    const isAllSelected =
      savedVehicleIds.length === allVehicleIds?.length &&
      allVehicleIds.every((id) => savedVehicleIds.includes(id));
    await this.setState({
      companyId: singleData[0].value,
      ruleId: getAlertDetails.ruleId,
      selectedVehicleIds: savedVehicleIds,
      selectAllVehicles: isAllSelected,
    });

    const enabledRuleSelector = getAlertDetails.ruleselector.find(
      (item) => item.isEnable === 1
    );

    if (enabledRuleSelector) {
      const selectedAlert = this.alertStore.alertNames.find(
        (item) => item.ruleSelectorId === enabledRuleSelector.ruleSelectorId
      );

      var parsedParams = JSON.parse(enabledRuleSelector.params);

      if (enabledRuleSelector.ruleSelectorId === 41) {
        if (
          parsedParams?.BLEMaxTemp1?.length > 0 ||
          parsedParams?.BLEMinTemp1?.length > 0
        )
          this.setState({ bletemp1: true });

        if (
          parsedParams?.BLEMaxTemp2?.length > 0 ||
          parsedParams?.BLEMinTemp2?.length > 0
        )
          this.setState({ bletemp2: true });

        if (
          parsedParams?.BLEMaxTemp3?.length > 0 ||
          parsedParams?.BLEMinTemp3?.length > 0
        )
          this.setState({ bletemp3: true });

        if (
          parsedParams?.BLEMaxTemp4?.length > 0 ||
          parsedParams?.BLEMinTemp4?.length > 0
        )
          this.setState({ bletemp4: true });

        if (
          parsedParams?.BLEMaxHumidity1?.length > 0 ||
          parsedParams?.BLEMinHumidity1?.length > 0
        )
          this.setState({ blehumidity1: true });

        if (
          parsedParams?.BLEMaxHumidity2?.length > 0 ||
          parsedParams?.BLEMinHumidity2?.length > 0
        )
          this.setState({ blehumidity2: true });

        if (
          parsedParams?.BLEMaxHumidity3?.length > 0 ||
          parsedParams?.BLEMinHumidity3?.length > 0
        )
          this.setState({ blehumidity3: true });

        if (
          parsedParams?.BLEMaxHumidity4?.length > 0 ||
          parsedParams?.BLEMinHumidity4?.length > 0
        )
          this.setState({ blehumidity4: true });
      }

      this.setState({
        selectedAlertName: selectedAlert.key,
        selectedAlertObject: selectedAlert,
      });
    }

    this.setState({
      isMailSelected: getAlertDetails.triggerAction == 1,
      isNotificationSelected: getAlertDetails.pushnotification === 1,
      isWebPushNotificationSelected: getAlertDetails.webpushnotification === 1,
    });

    const emailSubCheckBxArr = getAlertDetails.emailSubCheckBx
      ? getAlertDetails.emailSubCheckBx.split(",").map(Number)
      : [];

    this.setState({
      isAssetNoSelected: emailSubCheckBxArr.includes(1),
      isSpeedSelected: emailSubCheckBxArr.includes(2),
      isDistanceSelected: emailSubCheckBxArr.includes(3),
      isLocationSelected: emailSubCheckBxArr.includes(4),
      isTempratureSelected: emailSubCheckBxArr.includes(5),
    });

    await this.formRef.current.setFieldsValue({
      ...parsedParams,
      companyId: singleData,
      ruleName: getAlertDetails.name,
      notificationEmail: getAlertDetails.notificationEmail,
      notifyMobile: getAlertDetails.notifyMobile,
      active: getAlertDetails.active,
      sendpushnotification: getAlertDetails.pushNotification,
      vehicleNo: savedVehicleIds,
      minimumInterval: getAlertDetails.minimumInterval,
      // vehicleNo: getAlertDetails.vehicleId,
    });
    console.log(getAlertDetails.active, "getAlertDetails.active");
    this.setState({ active: getAlertDetails.active == "Yes" ? true : false });
    // this.formRef.current.setFieldsValue({ active: getAlertDetails.active });
    // await this.setState({ loadingSpin: false });

    this.setState({ loadList: 1 });
  }

  onAlertDetailSubmit = async (value) => {
    const RuleSelector = [
      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //1
        Ruleparams: JSON.stringify({
          SetDropSpeedLimit:
            this.state.selectedAlertName === "harshBraking"
              ? value.SetDropSpeedLimit
              : "",
        }),
        enable: this.state.selectedAlertName === "harshBraking" ? true : false,
      },
      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //2
        Ruleparams: JSON.stringify({
          SetAccelrSpeedLimit: value.SetAccelrSpeedLimit,
        }),
        enable:
          this.state.selectedAlertName === "harshAcceleration" ? true : false,
      },
      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //3,
        Ruleparams: JSON.stringify({
          Rule3SetVehicleSpeed:
            this.state.selectedAlertName === "seatBelt"
              ? value.Rule3SetVehicleSpeed
              : "",
        }),
        enable: this.state.selectedAlertName === "seatBelt" ? true : false,
      },
      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //4,
        Ruleparams: JSON.stringify({
          Rule4FromTime: value.Rule4FromTime,
          Rule4ToTime: value.Rule4ToTime,
          SetSpeedLimit: value.SetSpeedLimit,
          Days: value.Days,
        }),
        enable:
          this.state.selectedAlertName === "workingOutOfHours" ? true : false,
      },
      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //5,
        Ruleparams: JSON.stringify({
          Rule5SetTimeLimit: value.Rule5SetTimeLimit,
        }),
        enable:
          this.state.selectedAlertName === "vehicleStoppedReporting"
            ? true
            : false,
      },
      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //7,
        Ruleparams: JSON.stringify({
          Rule7SetSpeedLimit: value.Rule7SetSpeedLimit,
        }),
        enable: this.state.selectedAlertName === "overSpeeding" ? true : false,
      },

      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //10,
        Ruleparams: JSON.stringify({
          Rule10SetMinTemp: value.Rule10SetMinTemp,
          Rule10SetMaxTemp: value.Rule10SetMaxTemp,
        }),
        enable:
          this.state.selectedAlertName === "temperatureMonitoring"
            ? true
            : false,
      },
      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //15,
        Ruleparams: JSON.stringify({
          Rule15geofencename: value.Rule15geofencename,
          Rule15EventName: value.Rule15EventName,
        }),

        enable:
          this.state.selectedAlertName === "geofenceArrivalDeparture"
            ? true
            : false
            ? true
            : false,
      },
      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //16,
        Ruleparams: JSON.stringify({
          Rule16Assigndist: value.Rule16Assigndist,
        }),
        enable:
          this.state.selectedAlertName === "tripDistanceTravelled"
            ? true
            : false,
      },
      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //18,
        Ruleparams: JSON.stringify({
          Rule18SelInterval: value.Rule18SelInterval,
        }),
        enable:
          this.state.selectedAlertName === "sendLastPosition" ? true : false,
      },

      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //23,
        enable: this.state.selectedAlertName === "excessiveIdle" ? true : false,
      },
      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //24,
        enable: this.state.selectedAlertName === "ignition" ? true : false,
      },
      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //25,
        enable: this.state.selectedAlertName === "roadOverspeed" ? true : false,
      },
      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //26,
        Ruleparams: JSON.stringify({
          Rule26degreecentigrade: value.Rule26degreecentigrade,
        }),
        enable: this.state.selectedAlertName === "engineTemp" ? true : false,
      },
      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //27,
        enable:
          this.state.selectedAlertName === "vehicleHarshBraking" ? true : false,
      },
      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, // 28,
        enable:
          this.state.selectedAlertName === "vehicleHarshAcceleration"
            ? true
            : false,
      },
      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //29,
        enable:
          this.state.selectedAlertName === "vehicleHarshCornering"
            ? true
            : false,
      },
      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //30,
        enable: this.state.selectedAlertName === "panic" ? true : false,
      },

      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //31,
        enable: this.state.selectedAlertName === "powerCut" ? true : false,
      },
      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //32,
        Ruleparams: JSON.stringify({ Rule32TimeLimit: value.Rule32TimeLimit }),
        enable: this.state.selectedAlertName === "parking" ? true : false,
      },
      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //33,
        Ruleparams: JSON.stringify({
          Rule33geofencename: value.Rule33geofencename
            ? value.Rule33geofencename
            : "",
          Rule33TimeLimit: value.Rule33TimeLimit ? value.Rule33TimeLimit : "",
        }),
        enable: this.state.selectedAlertName === "stayAlert" ? true : false,
      },
      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //34,
        enable: this.state.selectedAlertName === "doorOpenClose" ? true : false,
      },
      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //35,
        enable: this.state.selectedAlertName === "towing" ? true : false,
      },
      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //36,
        enable:
          this.state.selectedAlertName === "mulkiyaRenewal" ? true : false,
      },
      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //37,
        enable:
          this.state.selectedAlertName === "InsuranceRenewal" ? true : false,
      },
      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //38,
        enable: this.state.selectedAlertName === "batteryChange" ? true : false,
      },
      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //39,
        enable:
          this.state.selectedAlertName === "serviceOilChange" ? true : false,
      },

      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //40,
        Ruleparams: JSON.stringify({
          Rule41geofencename: value.Rule41geofencename,
        }),
        enable:
          this.state.selectedAlertName === "areaWiseSpeedViolation"
            ? true
            : false,
      },
      {
        RuleSelectorId: this.state.selectedAlertObject.ruleSelectorId, //41,
        Ruleparams: JSON.stringify({
          BLEFromTime: value.BLEFromTime,
          BLEToTime: value.BLEToTime,
          BLEMinTemp1: this.state.bletemp1 ? value.BLEMinTemp1 : "",
          BLEMaxTemp1: this.state.bletemp1 ? value.BLEMaxTemp1 : "",
          BLEMinTemp2: this.state.bletemp2 ? value.BLEMinTemp2 : "",
          BLEMaxTemp2: this.state.bletemp2 ? value.BLEMaxTemp2 : "",
          BLEMinTemp3: this.state.bletemp3 ? value.BLEMinTemp3 : "",
          BLEMaxTemp3: this.state.bletemp3 ? value.BLEMaxTemp3 : "",
          BLEMinTemp4: this.state.bletemp4 ? value.BLEMinTemp4 : "",
          BLEMaxTemp4: this.state.bletemp4 ? value.BLEMaxTemp4 : "",
          BLEMinHumidity1: this.state.blehumidity1 ? value.BLEMinHumidity1 : "",
          BLEMaxHumidity1: this.state.blehumidity1 ? value.BLEMaxHumidity1 : "",
          BLEMinHumidity2: this.state.blehumidity2 ? value.BLEMinHumidity2 : "",
          BLEMaxHumidity2: this.state.blehumidity2 ? value.BLEMaxHumidity2 : "",
          BLEMinHumidity3: this.state.blehumidity3 ? value.BLEMinHumidity3 : "",
          BLEMaxHumidity3: this.state.blehumidity3 ? value.BLEMaxHumidity3 : "",
          BLEMinHumidity4: this.state.blehumidity4 ? value.BLEMinHumidity4 : "",
          BLEMaxHumidity4: this.state.blehumidity4 ? value.BLEMaxHumidity4 : "",
        }),
        enable:
          this.state.selectedAlertName === "bleTempHumidity" ? true : false,
      },
    ];

    const {
      isMailSelected,
      isNotificationSelected,
      isWebPushNotificationSelected,
    } = this.state;

    const emailSubCheckBx = this.getSelectedEmailSubCheckboxes();

    const filteredRule = RuleSelector.find((rule) => rule.enable);

    const data = {
      ...value,
      RuleSelector: filteredRule,
      companyId: this.state.companyId,
      ruleId: this.state.ruleId,
      vehicle: this.state.selectedVehicleIds,
      triggerAction: isMailSelected ? 1 : 0,
      pushnotification: isNotificationSelected ? 1 : 0,
      webpushnotification: isWebPushNotificationSelected ? 1 : 0,
      emailSubCheckBx: emailSubCheckBx,
      active: this.state.active ? "Yes" : "No",
      userId:this.props.getUserData().userId
    };

    // console.log("first", data);
    const response = await this.alertStore.addData(data);

    await this.props.response(response);

    this.setState({ loading: false });
  };

  getSelectedEmailSubCheckboxes = () => {
    const selected = [];

    if (this.state.isAssetNoSelected) selected.push(1); // asset number
    if (this.state.isSpeedSelected) selected.push(2); // speed
    if (this.state.isDistanceSelected) selected.push(3); // distance
    if (this.state.isLocationSelected) selected.push(4); // location
    if (this.state.isTempratureSelected) selected.push(5); // temperature

    return selected;
  };

  handleCheckboxChange = async (e) => {
    if (this.state.selectAllVehicles) {
      const allVehicles = this.alertStore?.vehicleList.map((val) => {
        return val.vehicleId;
      });

      await this.setState({ selectedVehicleIds: allVehicles });
      this.formRef.current?.setFieldsValue({
        vehicleNo: allVehicles,
      });
    } else {
      await this.setState({ selectedVehicleIds: [] });
      this.formRef.current?.setFieldsValue({
        vehicleNo: [],
      });
    }
  };

  render() {
    const sharedStyle = {
      backgroundColor: "#EFF6FF",
      border: "1px solid #d9d9d9",
      borderRadius: "8px",
      padding: "10px",
    };

    return (
      <div style={{ height: "100%" }}>
        <div style={{ height: "100%" }}>
          <Form
            layout="vertical"
            ref={this.formRef}
            onFinish={this.onAlertDetailSubmit}
            name="nest-message"
            className="formClass"
          >
            <div
              style={{
                display: "flex",
                gap: "12px",
                // height: "100%",
              }}
            >
              <div
                style={{
                  flex: this.state.selectedAlertName ? "0 0 54%" : "0 0 100%",
                  ...sharedStyle,
                }}
              >
                <Radio.Group
                  style={{ width: "100%", marginTop: "10px" }}
                  onChange={(e) => {
                    const selectedAlert = this.alertStore.alertNames.find(
                      (item) => item.key === e.target.value
                    );

                    this.setState({
                      selectedAlertName: e.target.value,
                      selectedAlertObject: selectedAlert,
                    });

                    this.formRef.current.setFieldsValue({
                      ruleName: selectedAlert.name,
                    });
                  }}
                  value={this.state.selectedAlertName}
                >
                  <Row gutter={[0, 12]}>
                    {this.alertStore?.alertNames?.map((item) => {
                      return (
                        <>
                          <Col span={12}>
                            <Radio value={item.key}>
                              {this.context.translate(item.nameLanguage)}
                            </Radio>
                          </Col>
                        </>
                      );
                    })}
                  </Row>
                </Radio.Group>
              </div>

              <div
                style={{
                  flex: "-5 0 46%",
                  ...sharedStyle,
                  display: this.state.selectedAlertName ? "block" : "none",
                }}
              >
                <h6 className="header">
                  {this.context.translate(
                    this.state.selectedAlertObject.nameLanguage
                  ) || ""}
                </h6>
                {(this.props.getUserData().isadmin === -1 ||
                  this.props.getUserData().isadmin === 3) && (
                  <Form.Item
                    name="companyId"
                    label={
                      <span>
                        {this.context.translate("_ACCOUNT_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_ACCOUNT_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                    className="uploadCompany"
                  >
                    <CompanyAutocomplete
                      onChange={async (value, e) => {
                        await this.handleChange(value);
                        this.formRef.current.setFieldsValue({
                          notificationEmail: e.contact1Email,
                          notifyMobile: e.contact1No,
                        });
                      }}
                      companyId={this.state.companyId}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                )}

                <Form.Item
                  className="uploadCompany"
                  name="ruleName"
                  label={
                    <span>
                      {this.context.translate(
                        "_FLEET_RULEADMIN_RULEDETAIL_RULENAME_"
                      )}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message:
                        this.context.translate(
                          "_FLEET_RULEADMIN_RULEDETAIL_RULENAME_"
                        ) +
                        " " +
                        this.context.translate("_IS_REQUIRED_"),
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  className="uploadCompany"
                  name="minimumInterval"
                  label={
                    <span>
                      {this.context.translate(
                        "_FLEET_RULEADMIN_RULEDETAIL_MININTERVAL_"
                      )}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message:
                        this.context.translate(
                          "_FLEET_RULEADMIN_RULEDETAIL_MININTERVAL_"
                        ) +
                        " " +
                        this.context.translate("_IS_REQUIRED_"),
                    },
                  ]}
                >
                  <Select>
                    <Select.Option value="10">10</Select.Option>
                    <Select.Option value="20">20</Select.Option>
                    <Select.Option value="30">30</Select.Option>
                    <Select.Option value="60">60</Select.Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  className="uploadCompany"
                  name="notificationEmail"
                  // label={this.context.translate(
                  //   "_FLEET_RULEADMIN_RULEDETAIL_NOTIFICATIONEMAIL_"
                  // )}
                  label={
                    <span>
                      {this.context.translate(
                        "_FLEET_RULEADMIN_RULEDETAIL_NOTIFICATIONEMAIL_"
                      )}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      // type: "email",
                      // message: "Please enter a valid email address",
                      message: this.context.translate(
                        "_PLEASE_ENTER_A_VALID_EMAIL_ADDRESS_"
                      ),
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  className="uploadCompany"
                  name="notifyMobile"
                  label={this.context.translate(
                    "_FLEET_RULEADMIN_RULEDETAIL_NOTIFICATIONMOBILE_"
                  )}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  className="uploadCompany"
                  name="active"
                  label={this.context.translate("_ACTIVE_")}
                  // valuePropName="checked"
                >
                  <Switch
                    checked={this.state.active}
                    onChange={(val) => {
                      this.setState({ active: val });
                    }}
                  />
                </Form.Item>

                <Form.Item
                  className="uploadCompany"
                  name="triggerAction"
                  label={this.context.translate(
                    "_FLEET_RULEADMIN_RULEDETAIL_TRIGGERACTION_"
                  )}
                  // label={
                  //   <span>
                  //     {this.context.translate(
                  //       "_FLEET_RULEADMIN_RULEDETAIL_TRIGGERACTION_"
                  //     )}{" "}
                  //     <span style={{ color: "red" }}>*</span>
                  //   </span>
                  // }
                  // required={false}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message:
                  //       this.context.translate(
                  //         "_FLEET_RULEADMIN_RULEDETAIL_TRIGGERACTION_"
                  //       ) +
                  //       " " +
                  //       this.context.translate("_IS_REQUIRED_"),
                  //   },
                  // ]}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "90px",
                      alignItems: "center",
                    }}
                  >
                    <Image
                      src={this.state.isMailSelected ? mailIconBlue : mailIcon}
                      onClick={() =>
                        this.setState({
                          isMailSelected: !this.state.isMailSelected,
                        })
                      }
                      style={{ cursor: "pointer" }}
                    />

                    <Image
                      src={
                        this.state.isNotificationSelected
                          ? notificationIconBlue
                          : notificationIcon
                      }
                      onClick={() =>
                        this.setState({
                          isNotificationSelected:
                            !this.state.isNotificationSelected,
                        })
                      }
                      style={{ cursor: "pointer" }}
                    />

                    <Image
                      src={
                        this.state.isWebPushNotificationSelected
                          ? notificationbellblue
                          : notificationbell
                      }
                      onClick={() =>
                        this.setState({
                          isWebPushNotificationSelected:
                            !this.state.isWebPushNotificationSelected,
                        })
                      }
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                </Form.Item>

                <Form.Item
                  className="uploadCompany"
                  name="emailSubCheckBx"
                  label={this.context.translate("_DEFAULT_PARAMETER_")}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "45px",
                      alignItems: "center",
                    }}
                  >
                    <Image
                      src={
                        this.state.isAssetNoSelected
                          ? carregistrationblue
                          : carregistration
                      }
                      onClick={() =>
                        this.setState({
                          isAssetNoSelected: !this.state.isAssetNoSelected,
                        })
                      }
                      style={{ cursor: "pointer" }}
                    />

                    <Image
                      src={
                        this.state.isSpeedSelected ? speedradarBlue : speedradar
                      }
                      onClick={() =>
                        this.setState({
                          isSpeedSelected: !this.state.isSpeedSelected,
                        })
                      }
                      style={{ cursor: "pointer" }}
                    />

                    <Image
                      src={
                        this.state.isDistanceSelected ? distanceBlue : distance
                      }
                      onClick={() =>
                        this.setState({
                          isDistanceSelected: !this.state.isDistanceSelected,
                        })
                      }
                      style={{ cursor: "pointer" }}
                    />

                    <Image
                      src={
                        this.state.isLocationSelected
                          ? locationIconBlue
                          : locationIcon
                      }
                      onClick={() =>
                        this.setState({
                          isLocationSelected: !this.state.isLocationSelected,
                        })
                      }
                      style={{ cursor: "pointer" }}
                    />

                    <Image
                      src={
                        this.state.isTempratureSelected
                          ? thermometerIconBlue
                          : thermometerIcon
                      }
                      onClick={() =>
                        this.setState({
                          isTempratureSelected:
                            !this.state.isTempratureSelected,
                        })
                      }
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                </Form.Item>

                <Space>
                  <Form.Item
                    className="uploadCompany"
                    name="vehicleNo"
                    label={
                      <span>
                        {this.context.translate("_VEHICLE_NO_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message:
                          this.context.translate("_VEHICLE_NO_") +
                          " " +
                          this.context.translate("_IS_REQUIRED_"),
                      },
                    ]}
                    style={{ width: "230px" }}
                  >
                    <Select
                      className="select-dropdown"
                      value={this.state.selectedVehicleIds}
                      mode="multiple"
                      maxTagCount="responsive"
                      showSearch
                      filterOption={(inputValue, option) => {
                        if (option.children) {
                          return (
                            option.children
                              .toLowerCase()
                              .indexOf(inputValue.toLowerCase()) >= 0
                          );
                        }
                      }}
                      onChange={(values) => {
                        this.setState({ selectedVehicleIds: values });

                        const allVehicleIds = this.alertStore?.vehicleList.map(
                          (v) => v.vehicleId
                        );

                        const allSelected =
                          values.length === allVehicleIds.length &&
                          allVehicleIds.every((id) => values.includes(id));

                        this.setState({ selectAllVehicles: allSelected });
                      }}
                    >
                      {this.alertStore?.vehicleList?.map((val) => {
                        return (
                          <Option key={val.vehicleId} value={val.vehicleId}>
                            {val.vehicleNo}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                  <Form.Item name="" label={""} style={{ marginTop: "10px" }}>
                    {" "}
                    <Checkbox
                      checked={this.state.selectAllVehicles}
                      onChange={async (e) => {
                        await this.setState({
                          selectAllVehicles: e.target.checked,
                        });

                        await this.handleCheckboxChange();
                      }}
                    />{" "}
                    All
                  </Form.Item>
                </Space>

                {this.state.selectedAlertName === "harshBraking" && (
                  <>
                    {" "}
                    <Form.Item
                      name="SetDropSpeedLimit"
                      label={
                        <span>
                          {this.context.translate(
                            "_FLEET_RULESELECTORDETAIL_RULE1_TITLE_"
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            this.context.translate(
                              "_FLEET_RULESELECTORDETAIL_RULE1_TITLE_"
                            ) +
                            " " +
                            this.context.translate("_IS_REQUIRED_"),
                        },
                      ]}
                    >
                      <Input
                        placeholder={this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_RULE1__SETSPEEDLIMIT_"
                        )}
                      ></Input>
                    </Form.Item>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "harshAcceleration" && (
                  <>
                    {" "}
                    <Form.Item
                      name="SetAccelrSpeedLimit"
                      label={
                        <span>
                          {this.context.translate(
                            "_FLEET_RULESELECTORDETAIL_RULE2_TITLE_"
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            this.context.translate(
                              "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                            ) +
                            " " +
                            this.context.translate("_IS_REQUIRED_"),
                        },
                      ]}
                    >
                      <Input
                        // placeholder="Set Accelerated Speed Limit(Km/Hr)"
                        placeholder={this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_RULE2_SETACCERSPEEDLIMIT_"
                        )}
                      ></Input>
                    </Form.Item>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "seatBelt" && (
                  <>
                    <Form.Item
                      name="Rule3SetVehicleSpeed"
                      label={
                        <span>
                          {this.context.translate(
                            "_FLEET_VEHICLEDETAIL_DIGITALIPDDL_SEATBELT1_"
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            this.context.translate(
                              "_FLEET_VEHICLEDETAIL_DIGITALIPDDL_SEATBELT1_"
                            ) +
                            " " +
                            this.context.translate("_IS_REQUIRED_"),
                        },
                      ]}
                    >
                      <Input
                        placeholder={this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_RULE3_SETVEHICLESPEED_"
                        )}
                      ></Input>
                    </Form.Item>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "workingOutOfHours" && (
                  <>
                    <Form.Item
                      name="Rule4FromTime"
                      label={
                        <span>
                          {this.context.translate(
                            "_FLEET_RULESELECTORDETAIL_RULE4_FROMTIME_"
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            this.context.translate(
                              "_FLEET_RULESELECTORDETAIL_RULE4_FROMTIME_"
                            ) +
                            " " +
                            this.context.translate("_IS_REQUIRED_"),
                        },
                      ]}
                    >
                      <Select>{this.timeOptions()}</Select>
                    </Form.Item>

                    <Form.Item
                      name="Rule4ToTime"
                      label={
                        <span>
                          {this.context.translate(
                            "_FLEET_RULESELECTORDETAIL_RULE4_TOTIME_"
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            this.context.translate(
                              "_FLEET_RULESELECTORDETAIL_RULE4_TOTIME_"
                            ) +
                            " " +
                            this.context.translate("_IS_REQUIRED_"),
                        },
                      ]}
                    >
                      <Select>{this.timeOptions()}</Select>
                    </Form.Item>

                    <Form.Item
                      name="SetSpeedLimit"
                      label={
                        <span>
                          {this.context.translate(
                            "_FLEET_RULESELECTORDETAIL_RULE4_SPEEDLIMIT_"
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            this.context.translate(
                              "_FLEET_RULESELECTORDETAIL_RULE4_SPEEDLIMIT_"
                            ) +
                            " " +
                            this.context.translate("_IS_REQUIRED_"),
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      name="Days"
                      label={
                        <span>
                          {this.context.translate("_DAYS_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            this.context.translate("_DAYS_") +
                            " " +
                            this.context.translate("_IS_REQUIRED_"),
                        },
                      ]}
                    >
                      <Select
                        className="select-dropdown"
                        mode="multiple"
                        maxTagCount={"responsive"}
                      >
                        <Select.Option value="0">
                          {this.context.translate("_SUNDAY_")}
                        </Select.Option>
                        <Select.Option value="1">
                          {this.context.translate("_MONDAY_")}
                        </Select.Option>
                        <Select.Option value="2">
                          {this.context.translate("_TUESDAY_")}
                        </Select.Option>
                        <Select.Option value="3">
                          {this.context.translate("_WEDNESDAY_")}
                        </Select.Option>
                        <Select.Option value="4">
                          {this.context.translate("_THURSDAY_")}
                        </Select.Option>
                        <Select.Option value="5">
                          {this.context.translate("_FRIDAY_")}
                        </Select.Option>
                        <Select.Option value="6">
                          {this.context.translate("_SATURDAY_")}
                        </Select.Option>
                      </Select>
                    </Form.Item>

                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "overSpeeding" && (
                  <>
                    <Form.Item
                      name="Rule7SetSpeedLimit"
                      // label={this.context.translate(
                      //   "_FLEET_RULESELECTORDETAIL_RULE7_SETSPEEDLIMIT_"
                      // )}
                      label={
                        <span>
                          {this.context.translate(
                            "_FLEET_RULESELECTORDETAIL_RULE7_SETSPEEDLIMIT_"
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: this.context.translate(
                            "_FLEET_RULESELECTORDETAIL_RULE7_SETSPEEDLIMIT_"
                          ),
                        },
                      ]}
                    >
                      <Input
                        // placeholder="Set Speed Limit(Km/hr)"
                        placeholder={this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_RULE7_SETSPEEDLIMIT_"
                        )}
                      ></Input>
                    </Form.Item>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName ===
                  "geofenceArrivalDeparture" && (
                  <>
                    <Form.Item
                      name="Rule15geofencename"
                      label={
                        <span>
                          {this.context.translate(
                            "_FLEET_RULESELECTORDETAIL_RULE6_GEOFENCE_"
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            this.context.translate(
                              "_FLEET_RULESELECTORDETAIL_RULE6_GEOFENCE_"
                            ) +
                            " " +
                            this.context.translate("_IS_REQUIRED_"),
                        },
                      ]}
                    >
                      <Select
                        className="select-dropdown"
                        maxTagCount={"responsive"}
                        // placeholder="Select Geofences"
                        placeholder={this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_RULE6_GEOFENCE_"
                        )}
                        mode="multiple"
                        onChange={(val) => {
                          this.formRef.current.setFieldsValue({
                            Rule15geofencename: val,
                          });
                        }}
                        showSearch
                        fieldNames={{ value: "zoneId", label: "name" }}
                        optionFilterProp="children"
                        options={this.alertStore?.geofencesList}
                      />
                    </Form.Item>

                    <Form.Item
                      name="Rule15EventName"
                      // label="Select Event"
                      // label={this.context.translate(
                      //   "_FLEET_RULESELECTORDETAIL_RULE8_EVENT_"
                      // )}

                      label={
                        <span>
                          {this.context.translate(
                            "_FLEET_RULESELECTORDETAIL_RULE8_EVENT_"
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            this.context.translate(
                              "_FLEET_RULESELECTORDETAIL_RULE8_EVENT_"
                            ) +
                            " " +
                            this.context.translate("_IS_REQUIRED_"),
                        },
                      ]}
                    >
                      <Select
                        placeholder={this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_RULE8_EVENT_"
                        )}
                        // placeholder="Select Event"
                      >
                        <Select.Option value="Inside/Outside">
                          {this.context.translate(
                            "_FLEET_RULESELECTORDETAIL_RULE12_EVENTDDL_INOUT_"
                          )}
                        </Select.Option>

                        <Select.Option value="Inside">
                          {this.context.translate(
                            "_FLEET_RULESELECTORDETAIL_RULE12_EVENTDDL_IN_"
                          )}
                        </Select.Option>
                        <Select.Option value="Outside">
                          {this.context.translate(
                            "_FLEET_RULESELECTORDETAIL_RULE12_EVENTDDL_OUT_"
                          )}
                        </Select.Option>
                      </Select>
                    </Form.Item>

                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "serviceReminder" && (
                  <>
                    <Form.Item
                      name="Rule18SelInterval"
                      // label={this.context.translate(
                      //   "_FLEET_RULESELECTORDETAIL_RULE15_SELECTINTERVAL_"
                      // )}

                      label={
                        <span>
                          {this.context.translate(
                            "_FLEET_RULESELECTORDETAIL_RULE15_SELECTINTERVAL_"
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            this.context.translate(
                              "_FLEET_RULESELECTORDETAIL_RULE15_SELECTINTERVAL_"
                            ) +
                            " " +
                            this.context.translate("_IS_REQUIRED_"),
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "InsuranceRenewal" && (
                  <>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "excessiveIdle" && (
                  <>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "roadOverspeed" && (
                  <>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "vehicleHarshBraking" && (
                  <>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "powerCut" && (
                  <>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "parking" && (
                  <>
                    <Form.Item
                      name="Rule32TimeLimit"
                      // label="Time Limit"
                      // label={this.context.translate("_TIME_LIMIT_")}
                      label={
                        <span>
                          {this.context.translate("_TIME_LIMIT_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: this.context.translate(
                            "_PLEASE_ENTER_TIME_LIMIT_"
                          ),
                        },
                      ]}
                    >
                      <Input
                        // placeholder="Set Parking Time Limit (Min)"
                        placeholder={this.context.translate(
                          "_SET_PARKING_TIME_LIMIT_"
                        )}
                      />
                    </Form.Item>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "accidentAlert" && (
                  <>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "nonStoppage" && (
                  <>
                    <Form.Item
                      name="nonStoppageMin"
                      // label="Time Limit"
                      // label={this.context.translate("_TIME_LIMIT_")}
                      label={
                        <span>
                          {this.context.translate("_NON_STOPPAGE_FOR_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            this.context.translate("_NON_STOPPAGE_FOR_") +
                            " " +
                            this.context.translate("_IS_REQUIRED_"),
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "unauthorizeDriving" && (
                  <>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "doorOpenClose" && (
                  <>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "passengerSeatbelt" && (
                  <>
                    <Form.Item
                      name="Rule34SetVehicleSpeed"
                      label={
                        <span>
                          {this.context.translate(
                            "_FLEET_VEHICLEDETAIL_DIGITALIPDDL_SEATBELT2_"
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            this.context.translate(
                              "_FLEET_VEHICLEDETAIL_DIGITALIPDDL_SEATBELT2_"
                            ) +
                            " " +
                            this.context.translate("_IS_REQUIRED_"),
                        },
                      ]}
                    >
                      <Input
                        placeholder={this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_RULE3_SETVEHICLESPEED_"
                        )}
                      ></Input>
                    </Form.Item>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "vehicleStoppedReporting" && (
                  <>
                    <Form.Item
                      name="Rule5SetTimeLimit"
                      label={
                        <span>
                          {this.context.translate(
                            "_FLEET_RULESELECTORDETAIL_RULE5_SETTIMELIMIT_"
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            this.context.translate(
                              "_FLEET_RULESELECTORDETAIL_RULE5_SETTIMELIMIT_"
                            ) +
                            " " +
                            this.context.translate("_IS_REQUIRED_"),
                        },
                      ]}
                    >
                      <Input
                        placeholder={this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_RULE5_SETTIMELIMIT_"
                        )}
                      ></Input>
                    </Form.Item>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "temperatureMonitoring" && (
                  <>
                    <Form.Item
                      name="Rule10SetMinTemp"
                      label={
                        <span>
                          {this.context.translate(
                            "_FLEET_RULESELECTORDETAIL_RULE9_SETTEMPERATURE_"
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            this.context.translate(
                              "_FLEET_RULESELECTORDETAIL_RULE9_SETTEMPERATURE_"
                            ) +
                            " " +
                            this.context.translate("_IS_REQUIRED_"),
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      name="Rule10SetMaxTemp"
                      label={
                        <span>
                          {this.context.translate(
                            "_FLEET_RULESELECTORDETAIL_RULE9_MAXTEMP_"
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            this.context.translate(
                              "_FLEET_RULESELECTORDETAIL_RULE9_MAXTEMP_"
                            ) +
                            " " +
                            this.context.translate("_IS_REQUIRED_"),
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>

                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "tripDistanceTravelled" && (
                  <>
                    <Form.Item
                      name="Rule16Assigndist"
                      label={
                        <span>
                          {this.context.translate(
                            "_FLEET_RULESELECTORDETAIL_RULE13_ASSIGNDISTANCE_"
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            this.context.translate(
                              "_FLEET_RULESELECTORDETAIL_RULE13_ASSIGNDISTANCE_"
                            ) +
                            " " +
                            this.context.translate("_IS_REQUIRED_"),
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "sendLastPosition" && (
                  <>
                    <Form.Item
                      name="Rule18SelInterval"
                      label={
                        <span>
                          {this.context.translate(
                            "_FLEET_RULESELECTORDETAIL_RULE15_SELECTINTERVAL_"
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            this.context.translate(
                              "_FLEET_RULESELECTORDETAIL_RULE15_SELECTINTERVAL_"
                            ) +
                            " " +
                            this.context.translate("_IS_REQUIRED_"),
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "mulkiyaRenwal" && (
                  <>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "ignition" && (
                  <>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "vehicleHarshCornering" && (
                  <>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "engineTemp" && (
                  <>
                    <Form.Item
                      name="Rule26degreecentigrade"
                      label={
                        <span>
                          {this.context.translate("Degree Centigrade")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            this.context.translate("Degree Centigrade") +
                            " " +
                            this.context.translate("_IS_REQUIRED_"),
                        },
                      ]}
                    >
                      <Input placeholder="°C" />
                    </Form.Item>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName ===
                  "vehicleHarshAcceleration" && (
                  <>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "panic" && (
                  <>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "stayAlert" && (
                  <>
                    <Form.Item
                      name="Rule33geofencename"
                      label={
                        <span>
                          {this.context.translate("_GEOFENCE_NAME_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            this.context.translate("_GEOFENCE_NAME_") +
                            " " +
                            this.context.translate("_IS_REQUIRED_"),
                        },
                      ]}
                    >
                      <Select
                        className="select-dropdown"
                        maxTagCount={"responsive"}
                        mode="multiple"
                        showSearch
                        fieldNames={{ value: "zoneId", label: "name" }}
                        optionFilterProp="children"
                        options={this.alertStore?.geofencesList}
                      />
                    </Form.Item>
                    <Form.Item
                      name="Rule33TimeLimit"
                      // label="Time Limit"
                      label={
                        <span>
                          {this.context.translate("_TIME_LIMIT_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            this.context.translate("_TIME_LIMIT_") +
                            " " +
                            this.context.translate("_IS_REQUIRED_"),
                        },
                      ]}
                    >
                      <Input
                        placeholder={this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_RULE5_SETTIMELIMIT_"
                        )}
                        // placeholder="Set Time Limit(Min)"
                      />
                    </Form.Item>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "towing" && (
                  <>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "bleTempHumidity" && (
                  <>
                    <Form.Item
                      name="BLEFromTime"
                      label={
                        <span>
                          {this.context.translate(
                            "_FLEET_RULESELECTORDETAIL_RULE4_FROMTIME_"
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            this.context.translate(
                              "_FLEET_RULESELECTORDETAIL_RULE4_FROMTIME_"
                            ) +
                            " " +
                            this.context.translate("_IS_REQUIRED_"),
                        },
                      ]}
                    >
                      <Select>{this.timeOptions()}</Select>
                    </Form.Item>

                    <Form.Item
                      name="BLEToTime"
                      label={
                        <span>
                          {this.context.translate(
                            "_FLEET_RULESELECTORDETAIL_RULE4_TOTIME_"
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            this.context.translate(
                              "_FLEET_RULESELECTORDETAIL_RULE4_TOTIME_"
                            ) +
                            " " +
                            this.context.translate("_IS_REQUIRED_"),
                        },
                      ]}
                    >
                      <Select>{this.timeOptions()}</Select>
                    </Form.Item>

                    <h6 className="header" style={{ marginTop: "10px" }}>
                      {this.context.translate("_BLE_TEMP_")}
                    </h6>

                    <Checkbox
                      checked={this.state.bletemp1}
                      onChange={async (e) => {
                        await this.setState({
                          bletemp1: e.target.checked,
                        });
                      }}
                    >
                      {this.context.translate("_BLE_TEMP1_")}
                    </Checkbox>

                    <div style={{ display: this.state.bletemp1 ? "" : "none" }}>
                      <Form.Item
                        name="BLEMinTemp1"
                        label={
                          <span>
                            {this.context.translate("_MIN_TEMP1_")}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        required={false}
                        rules={[
                          {
                            required: this.state.bletemp1,
                            message:
                              this.context.translate("_MIN_TEMP1_") +
                              " " +
                              this.context.translate("_IS_REQUIRED_"),
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                      <Form.Item
                        name="BLEMaxTemp1"
                        label={
                          <span>
                            {this.context.translate("_MAX_TEMP1_")}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        required={false}
                        rules={[
                          {
                            required: this.state.bletemp1,
                            message:
                              this.context.translate("_MAX_TEMP1_") +
                              " " +
                              this.context.translate("_IS_REQUIRED_"),
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                    </div>

                    <br />
                    <Checkbox
                      checked={this.state.bletemp2}
                      onChange={async (e) => {
                        await this.setState({
                          bletemp2: e.target.checked,
                        });
                      }}
                    >
                      {/* BLE Temp2 */}
                      {this.context.translate("_BLE_TEMP2_")}
                    </Checkbox>
                    {this.state.bletemp2 && (
                      <>
                        <Form.Item
                          name="BLEMinTemp2"
                          label={
                            <span>
                              {this.context.translate("_MIN_TEMP2_")}{" "}
                              <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                          required={false}
                          rules={[
                            {
                              required: this.state.bletemp2,
                              message:
                                this.context.translate("_MIN_TEMP2_") +
                                " " +
                                this.context.translate("_IS_REQUIRED_"),
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                        <Form.Item
                          name="BLEMaxTemp2"
                          label={
                            <span>
                              {this.context.translate("_MAX_TEMP2_")}{" "}
                              <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                          required={false}
                          rules={[
                            {
                              required: this.state.bletemp2,
                              message:
                                this.context.translate("_MAX_TEMP2_") +
                                " " +
                                this.context.translate("_IS_REQUIRED_"),
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </>
                    )}
                    <br />
                    <Checkbox
                      checked={this.state.bletemp3}
                      onChange={async (e) => {
                        await this.setState({
                          bletemp3: e.target.checked,
                        });
                      }}
                    >
                      {this.context.translate("_BLE_TEMP3_")}
                    </Checkbox>
                    {this.state.bletemp3 && (
                      <>
                        <Form.Item
                          name="BLEMinTemp3"
                          label={
                            <span>
                              {this.context.translate("_MIN_TEMP3_")}{" "}
                              <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                          required={false}
                          rules={[
                            {
                              required: this.state.bletemp3,
                              message:
                                this.context.translate("_MIN_TEMP3_") +
                                " " +
                                this.context.translate("_IS_REQUIRED_"),
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                        <Form.Item
                          name="BLEMaxTemp3"
                          label={
                            <span>
                              {this.context.translate("_MAX_TEMP3_")}{" "}
                              <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                          required={false}
                          rules={[
                            {
                              required: this.state.bletemp3,
                              message:
                                this.context.translate("_MAX_TEMP3_") +
                                " " +
                                this.context.translate("_IS_REQUIRED_"),
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </>
                    )}
                    <br />
                    <Checkbox
                      checked={this.state.bletemp4}
                      onChange={async (e) => {
                        await this.setState({
                          bletemp4: e.target.checked,
                        });
                      }}
                    >
                      {/* BLE Temp4 */}
                      {this.context.translate("_BLE_TEMP4_")}
                    </Checkbox>
                    {this.state.bletemp4 && (
                      <>
                        <Form.Item
                          name="BLEMinTemp4"
                          label={
                            <span>
                              {this.context.translate("_MIN_TEMP4_")}{" "}
                              <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                          required={false}
                          rules={[
                            {
                              required: this.state.bletemp4,
                              message:
                                this.context.translate("_MIN_TEMP4_") +
                                " " +
                                this.context.translate("_IS_REQUIRED_"),
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                        <Form.Item
                          name="BLEMaxTemp4"
                          label={
                            <span>
                              {this.context.translate("_MAX_TEMP4_")}{" "}
                              <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                          required={false}
                          rules={[
                            {
                              required: this.state.bletemp4,
                              message:
                                this.context.translate("_MAX_TEMP4_") +
                                " " +
                                this.context.translate("_IS_REQUIRED_"),
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </>
                    )}

                    <h6 className="header" style={{ marginTop: "10px" }}>
                      {this.context.translate("_BLE_HUMIDITY_")}
                    </h6>

                    <Checkbox
                      checked={this.state.blehumidity1}
                      onChange={async (e) => {
                        await this.setState({
                          blehumidity1: e.target.checked,
                        });
                      }}
                    >
                      {this.context.translate("_BLE_HUMIDITY1_")}
                    </Checkbox>
                    {this.state.blehumidity1 && (
                      <>
                        <Form.Item
                          name="BLEMinHumidity1"
                          label={
                            <span>
                              {this.context.translate("_MIN_HUMIDITY1_")}{" "}
                              <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                          required={false}
                          rules={[
                            {
                              required: this.state.blehumidity1,
                              message:
                                this.context.translate("_MIN_HUMIDITY1_") +
                                " " +
                                this.context.translate("_IS_REQUIRED_"),
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                        <Form.Item
                          name="BLEMaxHumidity1"
                          label={
                            <span>
                              {this.context.translate("_MAX_HUMIDITY1_")}{" "}
                              <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                          required={false}
                          rules={[
                            {
                              required: this.state.blehumidity1,
                              message:
                                this.context.translate("_MAX_HUMIDITY1_") +
                                " " +
                                this.context.translate("_IS_REQUIRED_"),
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </>
                    )}
                    <br />
                    <Checkbox
                      checked={this.state.blehumidity2}
                      onChange={async (e) => {
                        await this.setState({
                          blehumidity2: e.target.checked,
                        });
                      }}
                    >
                      {this.context.translate("_BLE_HUMIDITY2_")}
                    </Checkbox>
                    {this.state.blehumidity2 && (
                      <>
                        <Form.Item
                          name="BLEMinHumidity2"
                          label={
                            <span>
                              {this.context.translate("_MIN_HUMIDITY2_")}{" "}
                              <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                          required={false}
                          rules={[
                            {
                              required: this.state.blehumidity2,
                              message:
                                this.context.translate("_MIN_HUMIDITY2_") +
                                " " +
                                this.context.translate("_IS_REQUIRED_"),
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                        <Form.Item
                          name="BLEMaxHumidity2"
                          label={
                            <span>
                              {this.context.translate("_MAX_HUMIDITY2_")}{" "}
                              <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                          required={false}
                          rules={[
                            {
                              required: this.state.blehumidity2,
                              message:
                                this.context.translate("_MAX_HUMIDITY2_") +
                                " " +
                                this.context.translate("_IS_REQUIRED_"),
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </>
                    )}
                    <br />
                    <Checkbox
                      checked={this.state.blehumidity3}
                      onChange={async (e) => {
                        await this.setState({
                          blehumidity3: e.target.checked,
                        });
                      }}
                    >
                      {this.context.translate("_BLE_HUMIDITY3_")}
                    </Checkbox>
                    {this.state.blehumidity3 && (
                      <>
                        <Form.Item
                          name="BLEMinHumidity3"
                          label={
                            <span>
                              {this.context.translate("_MIN_HUMIDITY3_")}{" "}
                              <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                          required={false}
                          rules={[
                            {
                              required: this.state.blehumidity3,
                              message:
                                this.context.translate("_MIN_HUMIDITY3_") +
                                " " +
                                this.context.translate("_IS_REQUIRED_"),
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                        <Form.Item
                          name="BLEMaxHumidity3"
                          label={
                            <span>
                              {this.context.translate("_MAX_HUMIDITY3_")}{" "}
                              <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                          required={false}
                          rules={[
                            {
                              required: this.state.blehumidity3,
                              message:
                                this.context.translate("_MAX_HUMIDITY3_") +
                                " " +
                                this.context.translate("_IS_REQUIRED_"),
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </>
                    )}
                    <br />
                    <Checkbox
                      checked={this.state.blehumidity4}
                      onChange={async (e) => {
                        await this.setState({
                          blehumidity4: e.target.checked,
                        });
                      }}
                    >
                      {this.context.translate("_BLE_HUMIDITY4_")}
                    </Checkbox>

                    {this.state.blehumidity4 && (
                      <>
                        <Form.Item
                          name="BLEMinHumidity4"
                          label={
                            <span>
                              {this.context.translate("_MIN_HUMIDITY4_")}{" "}
                              <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                          required={false}
                          rules={[
                            {
                              required: this.state.blehumidity4,
                              message:
                                this.context.translate("_MIN_HUMIDITY4_") +
                                " " +
                                this.context.translate("_IS_REQUIRED_"),
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                        <Form.Item
                          name="BLEMaxHumidity4"
                          label={
                            <span>
                              {this.context.translate("_MAX_HUMIDITY4_")}{" "}
                              <span style={{ color: "red" }}>*</span>
                            </span>
                          }
                          required={false}
                          rules={[
                            {
                              required: this.state.blehumidity4,
                              message:
                                this.context.translate("_MAX_HUMIDITY4_") +
                                " " +
                                this.context.translate("_IS_REQUIRED_"),
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </>
                    )}

                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}
                {this.state.selectedAlertName === "gpsBatteryDisconnection" && (
                  <>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "areaWiseSpeedViolation" && (
                  <>
                    <Form.Item
                      name="Rule41geofencename"
                      label={
                        <span>
                          {this.context.translate(
                            "_FLEET_RULESELECTORDETAIL_RULE6_GEOFENCE_"
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: this.context.translate(
                            "_PLEASE_SELECT_GEOFENCE_"
                          ),
                        },
                      ]}
                    >
                      <Select
                        className="select-dropdown"
                        maxTagCount={"responsive"}
                        // placeholder="Select Geofences"
                        placeholder={this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_RULE6_GEOFENCE_"
                        )}
                        mode="multiple"
                        onChange={(val) => {
                          this.formRef.current.setFieldsValue({
                            Rule41geofencename: val,
                          });
                        }}
                        showSearch
                        fieldNames={{ value: "zoneId", label: "name" }}
                        optionFilterProp="children"
                        options={this.alertStore?.geofencesList}
                      />
                    </Form.Item>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "mulkiyaRenewal" && (
                  <>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "batteryChange" && (
                  <>
                    <div style={{ marginTop: "10px" }}>
                      <div className="alert-title">
                        {this.context.translate(
                          "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                        )}
                      </div>

                      <div className="alert-description">
                        {" "}
                        {this.context.translate(
                          this.state.selectedAlertObject.language
                        )}
                      </div>
                    </div>
                  </>
                )}

                {this.state.selectedAlertName === "serviceOilChange" && (
                  <div style={{ marginTop: "10px" }}>
                    <div className="alert-title">
                      {this.context.translate(
                        "_FLEET_RULESELECTORDETAIL_DESCRIPTION_"
                      )}
                    </div>

                    <div className="alert-description">
                      {" "}
                      {this.context.translate(
                        this.state.selectedAlertObject.language
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="formFooter">
              <Button
                className="formsCancelButton"
                onClick={() => {
                  this.closeModal();
                }}
              >
                {this.context.translate("_FLEET_DASHBORD_ROUTEADD_CANCELBTN_")}
              </Button>
              <Button
                htmlType="submit"
                loading={this.state.loading}
                className="formsSaveButton"
              >
                {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
              </Button>
            </div>
          </Form>
        </div>
      </div>
    );
  }
}

AlertAdd2.contextType = StoreContext;
export default observer(withRouter(AlertAdd2));
